import { StandardEvents } from '@shopify/events';

/**
 * <spec-grid> — swaps in the new variant's highlights from the section HTML
 * the variant picker already fetched.
 */
customElements.define(
  'spec-grid',
  class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.onSelect = (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        event.promise
          .then(({ detail }) => {
            const next = detail?.html?.querySelector(`spec-grid[data-block-id="${this.dataset.blockId}"]`);
            if (next) this.replaceChildren(...next.childNodes);
          })
          .catch(() => {});
      };
      this.section?.addEventListener(StandardEvents.productSelect, this.onSelect);
    }

    disconnectedCallback() {
      this.section?.removeEventListener(StandardEvents.productSelect, this.onSelect);
    }
  }
);
